<div class="group-qr mm-page">
  <header class="qa-dv-header">
    <h2>{{_(KEYS.CRUD.TITLE)}}</h2>
    <p>{{_(KEYS.CRUD.SUBTITLE)}}</p>
  </header>

  <!-- connect: the three steps next to the init code -->
  <section class="card qa-dv-card">
    <div class="card-body qa-dv-connect">
      <div class="qa-dv-connect-text">
        <h3>{{_(KEYS.CRUD.INIT_DEVICE)}}</h3>
        <ol class="qa-dv-steps">
          <li><span>1</span>{{_(KEYS.CRUD.STEP_INSTALL)}}</li>
          <li><span>2</span>{{_(KEYS.CRUD.STEP_WIFI)}}</li>
          <li><span>3</span>{{_(KEYS.CRUD.STEP_SCAN)}}</li>
        </ol>
        <div class="qa-dv-server">
          <span>{{_(KEYS.CRUD.SERVER)}}</span>
          <code [attr.title]="qrData">{{qrData}}</code>
        </div>
      </div>
      <div class="qa-dv-connect-qr">
        <app-init-device-qr-code></app-init-device-qr-code>
      </div>
    </div>
  </section>

  <!-- install: one tile per platform -->
  <ng-container *ngIf="iosAppLink || androidAppStoreLink || androidAppLink">
    <h3 class="qa-dv-section-title">{{_(KEYS.CRUD.INSTALL_APP)}}</h3>
    <p class="qa-dv-section-text">{{_(KEYS.CRUD.INSTALL_APP_TEXT)}}</p>

    <div class="qa-dv-apps">
      <section class="card qa-dv-card qa-dv-app" *ngIf="iosAppLink">
        <div class="card-body">
          <div class="qa-dv-app-head"><i class="fa fa-apple" aria-hidden="true"></i> {{_(KEYS.CRUD.IOS_STORE)}}</div>
          <div class="qr-wrap">
            <i class="fa fa-apple qr-inner" aria-hidden="true"></i>
            <qrcode [qrdata]="iosAppLink" [margin]="0" [width]="256" [errorCorrectionLevel]="'M'"
              [elementType]="'svg'" [colorLight]="'#ffffff00'"></qrcode>
          </div>
          <a class="btn btn-sm btn-outline-primary" [href]="iosAppLink" target="_blank" rel="noopener">
            <i class="fa fa-external-link" aria-hidden="true"></i> {{_(KEYS.CRUD.OPEN_STORE)}}
          </a>
        </div>
      </section>

      <section class="card qa-dv-card qa-dv-app" *ngIf="androidAppStoreLink">
        <div class="card-body">
          <div class="qa-dv-app-head"><i class="fa fa-android" aria-hidden="true"></i> {{_(KEYS.CRUD.ANDROID_STORE)}}</div>
          <div class="qr-wrap">
            <i class="fa fa-android qr-inner" aria-hidden="true"></i>
            <qrcode [qrdata]="androidAppStoreLink" [margin]="0" [width]="256" [errorCorrectionLevel]="'M'"
              [elementType]="'svg'" [colorLight]="'#ffffff00'"></qrcode>
          </div>
          <a class="btn btn-sm btn-outline-primary" [href]="androidAppStoreLink" target="_blank" rel="noopener">
            <i class="fa fa-external-link" aria-hidden="true"></i> {{_(KEYS.CRUD.OPEN_STORE)}}
          </a>
        </div>
      </section>

      <section class="card qa-dv-card qa-dv-app" *ngIf="androidAppLink">
        <div class="card-body">
          <div class="qa-dv-app-head"><i class="fa fa-android" aria-hidden="true"></i> {{_(KEYS.CRUD.ANDROID_DOWNLOAD)}}</div>
          <div class="qr-wrap">
            <i class="fa fa-android qr-inner" aria-hidden="true"></i>
            <qrcode [qrdata]="androidAppLink" [margin]="0" [width]="256" [errorCorrectionLevel]="'M'"
              [elementType]="'svg'" [colorLight]="'#ffffff00'"></qrcode>
          </div>
          <a class="btn btn-sm btn-outline-primary" [href]="androidAppLink" target="_blank" rel="noopener">
            <i class="fa fa-download" aria-hidden="true"></i> {{_(KEYS.CRUD.DOWNLOAD)}}
          </a>
        </div>
      </section>
    </div>
  </ng-container>
</div>
